module.exports = __webpack_public_path__ + "img/SH2D_30003.1bf959e8.png";